<template>
    <div class="container">
        <div class="toolbar shadow-sm">
            <img src="@/assets/icons/ConfigurationIcon.png" />
            <span class="title">{{ $t("admin.configuration.configuration_title") }}</span>
            <button v-bind:class="mapObjectStatusButtonClass" v-on:click="handleMapObjectStatusClicked()">{{ $t("admin.configuration.status_toolbar_button") }}</button>
            <button v-bind:class="bookingButtonClass" v-on:click="handleBookingClicked()">{{ $t("admin.configuration.booking_toolbar_button") }}</button>
        </div>

        <MapObjectStatusConfiguration v-if="selectedConfiguration == 'mapObjectStatus'"/>
        <BookingConfiguration v-if="selectedConfiguration == 'booking'"/>
    </div>
</template>

<script>
import MapObjectStatusConfiguration from "./MapObjectStatusConfiguration";
import BookingConfiguration from "./BookingConfiguration";

export default {
    components: {
        MapObjectStatusConfiguration,
        BookingConfiguration
    },

    computed: {
        mapObjectStatusButtonClass() {
            return this.selectedConfiguration == "mapObjectStatus" ? "btn btn-primary btn-sm" : "btn btn-outline-primary btn-sm";
        },

        bookingButtonClass() {
            return this.selectedConfiguration == "booking" ? "btn btn-primary btn-sm" : "btn btn-outline-primary btn-sm";
        }
    },

    data() {
        return {
            selectedConfiguration: "mapObjectStatus"
        }
    },

    methods: {
        handleMapObjectStatusClicked() {
            this.selectedConfiguration = "mapObjectStatus";
        },

        handleBookingClicked() {
            this.selectedConfiguration = "booking";
        }
    }
}
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
    margin: 0px;
    margin-bottom: 8px;
    width: 100%;
    max-width: none;
    text-align: left;
}

.toolbar {
    background-color: #ffffff;
    margin-bottom: 8px;
    padding: 8px;
    padding-left: 24px;
    text-align: left;
    width: 100%;
}

.toolbar img {
    margin-right: 16px;
    width: 50px;
}

.toolbar button {
    margin-right: 8px;
}

.toolbar .title {
    font-weight: bold;
    font-size: 18px;
    margin-right: 36px;
}
</style>